var map = {
	"./air_hum.png": "79d2",
	"./air_pm10.png": "1e3e",
	"./air_pm25.png": "ffdb",
	"./air_press.png": "b98f",
	"./air_temp.png": "5803",
	"./all_ok.png": "bd9b",
	"./bat_volt.png": "e5d4",
	"./co2.png": "5fe9",
	"./default.png": "b759",
	"./distance.png": "42c1",
	"./distance_liquid.png": "1fe8",
	"./double_relay_1.png": "0c18",
	"./double_relay_2.png": "f4a1",
	"./dragino_lt_relay_xxxx.png": "66b0",
	"./fire.png": "0bff",
	"./heating.png": "6e7e",
	"./lds_xxxx.png": "673a",
	"./lwl_xxxx.png": "0a58",
	"./motion.png": "d574",
	"./mtx_electricity_meter_x_xxxx.png": "bea3",
	"./outer_temp_device.png": "2e17",
	"./phase_a.png": "49c2",
	"./phase_b.png": "1d25",
	"./phase_c.png": "4fd4",
	"./pressure.png": "3173",
	"./soil_moisture.png": "d09e",
	"./soil_temp.png": "8d96",
	"./test.png": "7c0b",
	"./tvoc.png": "448b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa8c";